import React, { HTMLAttributes } from 'react';
import { useSelector } from 'react-redux';
import { View } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import {
  ImmutableEntity,
  ImmutableRootState,
} from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  TAXONOMY_MEDIA_CATEGORY_PUBLICATION,
  TAXONOMY_MEDIA_CATEGORY_CODE,
} from '../../../config/constants';

import {
  getOverviewUrlFromMenu,
} from '../../../helpers';

import EntitiesHighlighted from '../../../components/EntitiesHighlighted';
import { ParagraphDocumentsHighlighted as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphDocumentsHighlightedProps extends
  React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphDocumentsHighlighted: React.FC<ParagraphDocumentsHighlightedProps> =
  ({ entity }) => {
    const { t } = useTranslation();
    const paragraphDocumentsHighlighted = entity.toJS();
    const title = paragraphDocumentsHighlighted.field_title[0]?.value;
    const body = paragraphDocumentsHighlighted.field_body[0]?.processed;

    const menu = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['menu', 'main']));
    const overviewUrl = getOverviewUrlFromMenu(menu, 'publications');

    const documentBlockFilters = {
      field_media_category_target_id: [
        TAXONOMY_MEDIA_CATEGORY_PUBLICATION,
        TAXONOMY_MEDIA_CATEGORY_CODE,
      ],
    };

    return (
      <div className="Paragraph ParagraphDocumentsHighlighted">
        <Container>
          <div className="row">
            <div className="col-12">
              <EntitiesHighlighted
                title={title}
                body={body}
                link={overviewUrl}
                linkTitle={t('content_types.document.overview')}
              >
                <View
                  classes="row"
                  id="document"
                  display="documents_highlighted"
                  filters={documentBlockFilters}
                />
              </EntitiesHighlighted>
            </div>
          </div>
        </Container>
      </div>
    );
  };

export default ParagraphDocumentsHighlighted;
